/**
 * Created by agengmaulana on 2/22/17.
 */
import React from 'react'
import ReactDOM from 'react-dom';
import styles from './../../assets/css/comment.css'
import {observer} from "mobx-react"
import {observable} from 'mobx'
import { logException } from './../../../config'
// import Comment_Sweetalert from './../comment_sweetalert/comment_sweetalert'
import 'moment/locale/id'
import $ from 'jquery'
import escape_quotes from 'escape-quotes'
window.jQuery = $;
window.$ = $;
global.jQuery = $;
import emojioneArea from 'emojionearea'
const maxLength = 1000
const limitLength = (str, length) => str.substring(0, length);

@observer
export default class Comment_Form extends React.Component {

    @observable styleKomentar = {}
    @observable placeholder = 'Berikan Komentar Anda'
    @observable formConfig = {length:1000}
    @observable valueLength = ''
    @observable value = ''
    @observable error = null
    @observable id = 0
    @observable loading = false
    @observable butdisable = false
    @observable errorfetch = false


    constructor(props) {
        super(props);
        this.state={send: this.props.sendTo, idnya : this.props.parent_id}
    }



    render(){
        // this.loading = false

        const {dataStore,sendTo,parent_id} = this.props;
        dataStore.configKomentar.onresize()
        let sendto = sendTo == '2' ? styles.cmt_buka : styles.cmt_mb20
        let load = sendTo == '2' ? 'uil-ellipsis-css child' : 'uil-ellipsis-css'
        const trf ={
            transform : 'scale(0.27)'
        }

        const disabled = this.errorfetch == true ? 'disabled' : ''
        const id = parent_id != undefined ? parent_id : 0
        const idemoji= 'emojionearea'+id
        const cmt_lengthkoment= 'cmt_lengthkoment'+id
        let _ = this

        $(document).ready(function() {
            $('#emojionearea'+id).emojioneArea({
                pickerPosition: "bottom",
                autocomplete: false,
                hideSource: false,
                // autoHideFilters   : true,
                filters: {
                    people: {
                        icon: "yum",
                        emoji: "grinning,grin,joy,smiley,smile,sweat_smile,laughing,innocent,smiling_imp,imp,wink,blush," +
                        "relaxed,yum,relieved,heart_eyes,sunglasses,smirk,neutral_face,expressionless,unamused,sweat," +
                        "pensive,confused,confounded,kissing,kissing_heart,kissing_smiling_eyes,kissing_closed_eyes," +
                        "stuck_out_tongue,stuck_out_tongue_winking_eye,stuck_out_tongue_closed_eyes,disappointed,worried," +
                        "angry,rage,cry,persevere,triumph,disappointed_relieved,frowning,anguished,fearful,weary," +
                        "sleepy,tired_face,grimacing,sob,open_mouth,hushed,cold_sweat,scream,astonished,flushed," +
                        "sleeping,dizzy_face,no_mouth,mask,slight_frown,slight_smile,smile_cat,joy_cat,smiley_cat," +
                        "heart_eyes_cat,smirk_cat,kissing_cat,pouting_cat,crying_cat_face,scream_cat,footprints"
                    },
                },
                events: {
                    keypress: function (editor, event) {

                        var length = this.getText().length;
                        var val = this.getText();
                        if (length == 1000) {
                            event.preventDefault();
                            val.substr(0, 1000)
                        }
                        $('#cmt_lengthkoment' + id).val(maxLength - length)
                        if(sendTo == 2){
                            $('.emojionearea .emojionearea-editor').css('max-height','10em');
                        }
                        if(length > 1001){
                            event.preventDefault();
                            val.substr(0, 1000)
                            $('#cmt_lengthkoment'+id).val('0')
                        }
                        else{
                            $('#cmt_lengthkoment'+id).val(maxLength - length)
                        }
                        _.changeSize()
                    },
                    keyup: function (editor, event) {

                        var length = this.getText().length;
                        var val = this.getText();
                        if (length == 1000) {
                            event.preventDefault();
                            val.substr(0, 1000)
                        }
                        if(length > 1001){
                            event.preventDefault();
                            val.substr(0, 1000)
                            $('#cmt_lengthkoment'+id).val('0')
                        }
                        else{
                        $('#cmt_lengthkoment'+id).val(maxLength - length)
                        }
                        _.changeSize()
                    },
                    paste: function (editor, event) {
                        var length = this.getText().length;
                        var val = this.getText();
                        if (length == 1000) {
                            val.substr(0, 1000)

                        }
                        if(length > 1001){
                            var ntex = val.substr(0, 1000)
                            this.setText(ntex)
                            $('#cmt_lengthkoment'+id).val('0')
                        }
                        else{
                            $('#cmt_lengthkoment'+id).val(maxLength - length)
                        }
                        _.changeSize()
                    },
                    emojibtn_click: function (button, event) {

                        var length = this.getText().length;
                        var val = this.getText();
                        if (length == 1000) {
                            event.preventDefault();
                            val.substr(0, 1000)
                        }
                        if(length > 1001){
                            event.preventDefault();
                            val.substr(0, 1000)
                            $('#cmt_lengthkoment'+id).val('0')
                        }
                        else{
                            $('#cmt_lengthkoment'+id).val(maxLength - length)
                        }
                        _.changeSize()
                    },
                    focus: function (editor, event) {
                        var length = this.getText().length;
                        var val = this.getText();
                        if (length == 1000) {
                            event.preventDefault();
                            val.substr(0, 1000)

                        }
                        if(length > 1001){
                            event.preventDefault();
                            val.substr(0, 1000)
                            $('#cmt_lengthkoment'+id).val('0')
                        }
                        else{
                            $('#cmt_lengthkoment'+id).val(maxLength - length)
                        }
                        _.changeSize()
                    },
                    change: function (editor, event) {
                        var length = this.getText().length;
                        var val = this.getText();
                        if (length == 1000) {
                            val.substr(0, 1000)

                        }

                        if(length > 1001){
                            val.substr(0, 1000)
                            $('#cmt_lengthkoment'+id).val('0')
                        }
                        else{
                            $('#cmt_lengthkoment'+id).val(maxLength - length)
                        }
                        _.changeSize()
                    },
                    click: function (button, event) {

                        var length = this.getText().length;
                        var val = this.getText();
                        if (length == 1000) {
                            event.preventDefault();
                            val.substr(0, 1000)
                        }
                        if(length > 1001){
                            event.preventDefault();
                            val.substr(0, 1000)
                            $('#cmt_lengthkoment'+id).val('0')
                        }
                        else{
                            $('#cmt_lengthkoment'+id).val(maxLength - length)
                        }
                        _.changeSize()
                    },
                    mousedown: function (editor, event) {
                        var length = this.getText().length;
                        var val = this.getText();
                        if (length == 1000) {
                            event.preventDefault();
                            val.substr(0, 1000)
                        }
                        if(length > 1001){
                            event.preventDefault();
                            val.substr(0, 1000)
                            $('#cmt_lengthkoment'+id).val('0')
                        }
                        else{
                            $('#cmt_lengthkoment'+id).val(maxLength - length)
                        }
                        _.changeSize()
                    },
                    mouseup: function (editor, event) {
                        var length = this.getText().length;
                        var val = this.getText();
                        if (length == 1000) {
                            event.preventDefault();
                            val.substr(0, 1000)
                        }
                        if(length > 1001){
                            event.preventDefault();
                            val.substr(0, 1000)
                            $('#cmt_lengthkoment'+id).val('0')
                        }
                        else{
                            $('#cmt_lengthkoment'+id).val(maxLength - length)
                        }
                        _.changeSize()
                    },
                }
            });
            if(dataStore.formStore.parentId == id) {

                $('#emojionearea'+id).data("emojioneArea").setText(dataStore.formStore.content);
            }
        });
        return(
            <div className={styles.cmt_box_dk +' '+sendto} >

                <form onSubmit={this.submit} id={'form'+id} className={styles.cmt_form} >
                    <div className={styles.cmt_text_komentar}>
                        <textarea ref="Inputdata" id={idemoji} name="text_komen" className={styles.cmt_emot+' '+styles.cmt_textarea}
                                  minLength="3" maxLength={maxLength} onClick={this.checkLogin} onChange={this.handleChange}
                                  defaultValue={this.value} placeholder={this.placeholder} />

                    </div>
                    <div className={styles.cmt_dk_bot}>
                        {this.loading ?
                            <div  className={styles.cmt_loading_send}>
                                <div className={load} style={trf}>
                                    <div className="ib">
                                        <div className="cmt_circle"><div>
                                        </div>
                                        </div>
                                        <div className="cmt_circle"><div>

                                        </div>
                                        </div>
                                        <div className="cmt_circle"><div>

                                        </div></div>
                                        <div className="cmt_circle"><div></div>
                                        </div>
                                    </div>
                                </div>
                                <div><div className={styles.cmt_loading_send}> sedang mengirim komentar</div></div>
                                <div></div>
                            </div> : ''
                        }
                        <div>
                            <input type="submit" className={styles.cmt_btn +' '+ styles.cmt_fr} defaultValue="KIRIM" disabled={this.butdisable}/>
                            <input type="text" name="countdown" id={cmt_lengthkoment} size="4" className={styles.cmt_lengthkoment+' '+styles.cmt_input_text} value="1000" readOnly={true}/>Karakter tersisa
                        </div>
                        </div>
                </form>
            </div>

        )


    }

    changeSize=()=> {
        this.props.dataStore.configKomentar.onresize()
    }

    handleChange=(event)=> {

        this.valueLength = limitLength(event.target.value,maxLength)
        this.formConfig.length = maxLength - event.target.value.length

    }

    submit=(e)=>{

        e.preventDefault()
        var val;
        if(this.props.parent_id == null || this.props.parent_id == undefined){
            val = $("#emojionearea0").data("emojioneArea").getText()
        }
        else {
            val = $("#emojionearea"+this.props.parent_id).data("emojioneArea").getText()
        }

        var substr = escape_quotes(val.substring(0,1000), '"', "\\");
        var escapequotes = substr.replace(/[\b]/g, '\\b')
                            .replace(/[\b]/g, '\\b')
                            .replace(/[\f]/g, '\\f')
                            .replace(/[\n]/g, ' ')
                            .replace(/[\r]/g, '\\r')
                            .replace(/[\t]/g, '\\t');
        var escape_string = escape(escapequotes)

        const trim = escape_string.trim();
        const validateInput = this.validateInput(trim);
        if (validateInput) {
            this.error = validateInput
            return;
        }
        else if (trim.length > 0  && trim.length <= 10){
            this.props.dataStore.configKomentar.onalert('Komentar Harus Lebih dari 10 Karakter')
        }

        else if (trim.length > 10) {
            this.loading = true
            this.butdisable = true
            if(this.state.send == 2){
                this.addKomentarChild(escape_string,this.props.refer_id,this.props.parent_id)
                setTimeout(()=>{ this.props.closeForm()},2000);
            }
            else{
                this.addKomentar(escape_string,escapequotes)
            }

        }

    }

    validateInput(task) {
        if (!task || task == ' ' ) {
            console.log(task)
            this.props.dataStore.configKomentar.onalert('Komentar Tidak Boleh Kosong')
        }
        else {
            return null;
        }
    }

    addKomentarChild (content,refer_id,parent_id) {
        if(this.props.dataStore.profile.id !='') {
            var hasil = this.props.dataStore.configKomentar.link ? this.props.dataStore.configKomentar.link : this.props.dataStore.configKomentar.currentUrl;
            var escape_stringtitle = encodeURIComponent(this.props.dataStore.configKomentar.title.trim());
            var params = {
                artikel: this.props.dataStore.configKomentar.identifier,
                date: this.props.dataStore.configKomentar.date,
                title: escape_stringtitle,
                prokontra: this.props.dataStore.configKomentar.prokontra,
                kanal: this.props.dataStore.configKomentar.group,
                site: this.props.dataStore.configKomentar.site,
                parent: parent_id,
                refer: refer_id,
                content: content,
                link: hasil,
            }

            var insert =
                'mutation commentInsert($artikel: Int!, $date: String!, $title: String!, $prokontra: String!, $kanal: Int!, $site: String!, $parent: Int! , $refer: Int! , $content: String!, $link: String!) { ' +
                'commentInsert(artikel: $artikel, date: $date, title: $title, prokontra: $prokontra, kanal: $kanal, site: $site, parent: $parent , refer: $refer , content: $content, link: $link) { ' +
                'status message moderasi comments{ id } } }';

            var urls = this.props.dataStore.url_api_comment +'graphql?'

            fetch(urls, {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({query: insert, variables: params})
            })
                .then((response) => {
                    if(response.ok === false){
                        logException(new Error(response.statusText),{
                            'bodyUsed': response.bodyUsed,
                            'ok': response.ok,
                            'redirected': response.redirected,
                            'status': response.status,
                            'statusText': response.statusText,
                            'type': response.type,
                            'url': response.url
                        });
                    }
                    return response.json()
                })
                .then((data) => {

                    this.loading = false
                    this.butdisable = false


                    if (data.data.commentInsert.status == true) {
                        const id = data.data.commentInsert.comments.id
                        this.props.dataStore.anchor = ''
                        setTimeout(()=> {
                            this.props.dataStore.configKomentar.onscroll(id)
                        },700)
                        this.props.dataStore.addKomentarChild(id, parent_id, content,refer_id,data.data.commentInsert.moderasi)
                        $('#emojionearea' + parent_id).data("emojioneArea").setText("");
                    }
                    else if (data.data.commentInsert.status == false) {
                        this.props.dataStore.configKomentar.onalert(data.data.commentInsert.message)

                    }

                })
                .catch((reason) => {
                    this.props.dataStore.configKomentar.onalert("Terjadi gangguan, mohon mencoba beberapa saat lagi");
                    console.log('catch : ', reason);
                })
        }
        else {
            this.loading = false
            this.butdisable = false
            this.props.dataStore.configKomentar.onmasuk()
        }

    }

    addKomentar (content,escapequotes) {

        if(this.props.dataStore.profile.id !=''){
            var hasil = this.props.dataStore.configKomentar.link ? this.props.dataStore.configKomentar.link : this.props.dataStore.configKomentar.currentUrl;
            var params = {
                artikel: this.props.dataStore.configKomentar.identifier,
                date: this.props.dataStore.configKomentar.date,
                title: encodeURIComponent(this.props.dataStore.configKomentar.title.trim()),
                prokontra: this.props.dataStore.configKomentar.prokontra,
                kanal: this.props.dataStore.configKomentar.group,
                site: this.props.dataStore.configKomentar.site,
                content: content,
                link: hasil,
            }

            var insert ="mutation commentInsert($artikel: Int!,$date: String!, $title: String!, $prokontra: String!, $kanal: Int!, $site: String!, $content: String!, $link: String!)" +
                "{ commentInsert(artikel: $artikel ,date: $date, title: $title, prokontra: $prokontra, kanal: $kanal, site: $site, content: $content, link: $link) { status message moderasi comments{ id } } }";

            var urls = this.props.dataStore.url_api_comment +'graphql'

            fetch(urls, {
                timeout: 2000,
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({query: insert, variables: params})
            })
                .then( (response) => {
                    if(response.ok === false){
                        logException(new Error(response.statusText),{
                            'bodyUsed': response.bodyUsed,
                            'ok': response.ok,
                            'redirected': response.redirected,
                            'status': response.status,
                            'statusText': response.statusText,
                            'type': response.type,
                            'url': response.url
                        });
                    }
                    return response.json()
                })
                .then((datad) => {
                    setTimeout(()=>{
                    if(datad.data.commentInsert.status == true){

                        const id = datad.data.commentInsert.comments.id
                        this.props.dataStore.addKomentar(content,id,datad.data.commentInsert.moderasi)
                        this.refs.Inputdata.value= ''
                        this.value = '';
                        this.props.dataStore.formStore = ''
                        localStorage.removeItem(this.props.dataStore.configKomentar.identifier);
                        $("#emojionearea0").data("emojioneArea").setText("");


                    }
                    else if(datad.data.commentInsert.status == false){
                        // this.props.dataStore.show = true
                        // this.props.dataStore.text = datad.data.commentInsert.message
                        // this.props.dataStore.title = 'Peringatan'
                        this.props.dataStore.configKomentar.onalert(datad.data.commentInsert.message)
                    }

                    this.loading = false
                    this.butdisable = false
                    },2000)
                }).catch((reason) => {
                this.props.dataStore.configKomentar.onalert("Terjadi gangguan, mohon mencoba beberapa saat lagi");
                console.log('catch : ', reason);
            })
        }
        else {
            this.loading = false
            this.butdisable = false
            const tostorage = {
                "artikel": this.props.dataStore.configKomentar.identifier,
                "kanal": this.props.dataStore.configKomentar.group,
                "parentId": 0,
                "content": escapequotes,
                "site": this.props.dataStore.configKomentar.site,
                "prokontra": this.props.dataStore.configKomentar.prokontra,
                "title": this.props.dataStore.configKomentar.title.trim()
            }

            localStorage.setItem(this.props.dataStore.configKomentar.identifier, JSON.stringify(tostorage) );

            this.props.dataStore.configKomentar.onmasuk()

        }

    }

}



// WEBPACK FOOTER //
// ./static/src/component/comment_form/comment_form.js